import { Drawer } from "antd";
import DocumentViewer from "components/DocumentViewer";

interface PdfDrawerProps {
  open: boolean;
  onClose: () => void;
  pdfUrl: string;
  loading?: boolean;
}

export default function PdfDrawer({ open, onClose, pdfUrl, loading }: PdfDrawerProps) {
  return (
    <Drawer
      className="modal-pdf-preview modal-pdf-preview--headerless"
      width="100%"
      height="100vh"
      open={open}
      placement="bottom"
      onClose={onClose}
      closable={false}
      footer={null}
    >
      {pdfUrl && <DocumentViewer previewDocumentUrl={pdfUrl} loading={loading} onClose={onClose} />}
    </Drawer>
  );
}
